import React from "react";
import { SvgIcon } from "@material-ui/core";

export const AiSparkleIcon = (props) => (
	<SvgIcon {...props}>
		{/* Large 4-point star */}
		<path d="M12 3l2.5 7.5L22 13l-7.5 2.5L12 23l-2.5-7.5L2 13l7.5-2.5z" />
		{/* Medium 4-point star (upper-right, lifted higher) */}
		<path d="M18 2.5l1.2 3.5L23 7.2l-3.8 1.2L18 12l-1.2-3.6-3.8-1.2 3.8-1.2z" transform="translate(1 -1)" />
		{/* Small 4-point star (lower-right) */}
		<path d="M19.5 15.5l0.7 2.1 2.1 0.7-2.1 0.7-0.7 2.1-0.7-2.1-2.1-0.7 2.1-0.7z" transform="translate(-2 0)" />
	</SvgIcon>
);
